import {DataListCell} from "@patternfly/react-core";

export const ConstraintCellFake = () => {
  return <DataListCell width={1} />;
};
